import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';
import { getWeekStartByLocale } from 'weekstart';
import { businessHoursDefaultProps } from '../common/business-hours-default-props';
import type { BusinessHoursProps } from '../common/business-hours-types';
import { Weekday } from '../common/business-hours-types';

const BusinessHoursPropsContext = createContext<BusinessHoursProps>(
  businessHoursDefaultProps
);

export function BusinessHoursPropsProvider({
  children,
  ...settings
}: PropsWithChildren<Partial<BusinessHoursProps>>) {
  return (
    <BusinessHoursPropsContext.Provider
      value={{
        ...businessHoursDefaultProps,
        ...settings,
        firstWeekday:
          settings.firstWeekday || getWeekStart(settings.language?.language),
        timeZone:
          settings.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone
      }}
    >
      {children}
    </BusinessHoursPropsContext.Provider>
  );
}

const getWeekStart = (locale = window.navigator.language): Weekday => {
  const resolvedIndex = getWeekStartByLocale(locale);
  return Object.values(Weekday)[resolvedIndex];
};

export const useBusinessHoursProps = () => {
  return useContext(BusinessHoursPropsContext);
};
